"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var SearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter"));
var utils_1 = require("./utils");
var CustomersSearchAndFilter = function (_a) {
    var rechargedCustomers = _a.rechargedCustomers, selectedFilters = _a.selectedFilters, setSelectedFilters = _a.setSelectedFilters, searchText = _a.searchText, setSearchText = _a.setSearchText;
    var opts = utils_1.filterGroupDefinitions.map(function (_a) {
        var makeOptions = _a.makeOptions;
        return makeOptions(rechargedCustomers);
    }).flat();
    return ((0, jsx_runtime_1.jsx)(SearchAndFilter_1.default, { searchProperties: { searchText: searchText, setSearchText: setSearchText }, filterProperties: { options: opts, results: selectedFilters, setResults: setSelectedFilters } }));
};
exports.default = react_1.default.memo(CustomersSearchAndFilter);
